import { FLOWER_IDS, FLOWERS, RARITY_INFO } from '../../game/flowers';
import { Panel } from '../components/Panel';
import { useGameState } from '../context';

export function AlmanacPanel() {
  const state = useGameState();
  const found = FLOWER_IDS.filter((id) => (state.almanac[id]?.harvested ?? 0) > 0).length;
  return (
    <Panel title="Flower Almanac" icon="📖" wide>
      <div class="banner">
        Discovered <b>{found}</b> of <b>{FLOWER_IDS.length}</b> flowers
        <div class="xp-bar wide">
          <div class="xp-fill" style={{ width: `${(found / FLOWER_IDS.length) * 100}%` }} />
        </div>
      </div>
      <ul class="almanac">
        {FLOWER_IDS.map((id) => {
          const def = FLOWERS[id];
          const entry = state.almanac[id];
          const known = (entry?.harvested ?? 0) > 0;
          const rarity = RARITY_INFO[def.rarity];
          if (!known && def.parents) {
            const [a, b] = def.parents;
            return (
              <li key={id} class="almanac-card mystery" style={{ borderColor: rarity.color }}>
                <div class="almanac-emoji">❔</div>
                <b>???</b>
                <span class="rarity" style={{ background: rarity.color }}>
                  {rarity.label}
                </span>
                <p class="card-text">
                  Rumour has it this blooms where {FLOWERS[a].emoji} and {FLOWERS[b].emoji} grow
                  side by side…
                </p>
              </li>
            );
          }
          return (
            <li
              key={id}
              class={`almanac-card ${known ? '' : 'unknown'}`}
              style={{ borderColor: rarity.color }}
            >
              <div class="almanac-emoji">{def.emoji}</div>
              <b>{def.name}</b>
              <span class="rarity" style={{ background: rarity.color }}>
                {rarity.label}
              </span>
              <p class="card-text">{def.description}</p>
              <div class="almanac-stats">
                {known ? (
                  <>
                    🌸 {entry?.harvested} grown{entry?.golden ? ` · ✨ ${entry.golden} golden` : ''}
                  </>
                ) : (
                  <>Not grown yet</>
                )}
                <br />⏱ {def.growTime}s · 🪙{def.sellPrice}
              </div>
            </li>
          );
        })}
      </ul>
    </Panel>
  );
}
